import { FC, useCallback, useState } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { deleteHomeActionCreator } from 'actions/propertyActions'
import ConfirmModalComponent from 'components/features/pfm/ConfirmModal/ConfirmModal'

type HouseDeleteHandlerProps = {
  homeId: number
  onConfirm?: () => void
}
export const HouseDeleteHandler: FC<HouseDeleteHandlerProps> = (props) => {
  const { children, homeId, onConfirm } = props

  const [isConfirmShown, setIsConfirmShown] = useState(false)
  const showConfirm = useCallback(() => setIsConfirmShown(true), [])
  const hideConfirm = useCallback(() => setIsConfirmShown(false), [])

  const dispatch = useStoreDispatch()
  const handleConfirm = useCallback(() => {
    hideConfirm()
    dispatch(deleteHomeActionCreator(homeId))
    onConfirm && onConfirm()
  }, [dispatch, homeId, onConfirm, hideConfirm])

  return (
    <>
      <span onClick={ showConfirm }>
        { children }
      </span>
      { isConfirmShown && (
        <ConfirmModalComponent onCancel={ hideConfirm } onConfirm={ handleConfirm } confirmButtonText='Delete'>
          Deleting this home will permanently remove all of its historical data as well. Are you sure you want to delete this home?
        </ConfirmModalComponent>
      )}
    </>
  )
}
